import { useState, useEffect, useCallback } from 'react';
import { api } from '@/lib/api';
import type { Tier } from '@/types';

interface UseTiersOptions {
  includeStripeIds?: boolean;
}

export function useTiers(options: UseTiersOptions = {}) {
  const { includeStripeIds = false } = options;
  const [tiers, setTiers] = useState<Tier[]>([]);
  const [betaPhase, setBetaPhase] = useState(true);
  const [betaMessage, setBetaMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTiers = useCallback(async () => {
    try {
      setIsLoading(true);
      const data = await api.getTiers(includeStripeIds);
      setTiers(data.tiers);
      setBetaPhase(data.beta_phase);
      setBetaMessage(data.beta_message || null);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load tiers');
    } finally {
      setIsLoading(false);
    }
  }, [includeStripeIds]);

  useEffect(() => {
    fetchTiers();
  }, [fetchTiers]);

  return { tiers, betaPhase, betaMessage, isLoading, error, refresh: fetchTiers };
}

